import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import {
  context_styles
} from "../context_builder_dark_styles";
import "../context_dark.css";
import { LinearProgressDark } from "../context_components/styled_linear_progress";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSpring, animated } from '@react-spring/web';
import { StyledAutocompleteDark } from "../context_components/styled_autocomplete";
import { alpha, styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { projectInfoActions, contextBuilderActions, defaultTabActions, sosAndSodActions } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import { makeStyles } from '@mui/styles';
import { Projects } from "../context_components/projects";

const useAutoCompleteStyles = makeStyles({
  option: {
    fontSize: '0.875rem',
  },
});



export default function ProjectSwitcher(props) {
  const autocomplete_classes = useAutoCompleteStyles();
  const { projectInfo, dateTime, projects } = useSelector(state => state.projectInfoStore);
  const {
    color
  } = useSelector(state => state.themeStore);
  const {
    page,
    prevPage
  } = useSelector(state => state.contextBuilderStore);
  const dispatch = useDispatch();

  const [springs, api] = useSpring(() => ({
    from: {
      y: 0
    },
    config: {
      mass: 7
    }
  }))

  useEffect(() => {
    api.start({
      from: {
        y: -15 + "%"
      },
      to: {
        y: 0 + "%"
      }
    })
  }, [])

  const handlePageChange = () => {
    dispatch(contextBuilderActions.changePage(prevPage));
  }

  const handleOptionChange = (e, type) => {
    const selectedConfig = projects.filter(r => (
      (r.tag === e)
    ))[0]
    dispatch(projectInfoActions.changeProjectConfig([selectedConfig.country, selectedConfig.env, selectedConfig.projectName]));
    dispatch(defaultTabActions.resetDefaultTabStateToDefault());
    dispatch(sosAndSodActions.setSodResponse([]))
  }

  const currentProject = projects.filter(r => (
    (r.country === projectInfo[0]) &&
    (r.env === projectInfo[1])
  ))[0]

  return (
    <animated.div style={{ ...springs }}>
      <Paper elevation={5} sx={context_styles}>
        {props.load &&
          <LinearProgressDark className="context-loader-dark" />
        }
        <Stack
          spacing={1.5}
          className="container"
        >
          <Stack direction="row" className="page-header-dark">
            <ChevronLeftIcon className="left-dark" onClick={handlePageChange} />
            <span>Project Config</span>
            <span className="right-dark"></span>
          </Stack>

          <Stack
            className="project-switcher-content"
            spacing={2}
          >
            {projects.length > 0 &&
              <StyledAutocompleteDark
                sx={{ width: "15rem" }}
                classes={{
                  option: autocomplete_classes.option,
                }}
                id="size-small-outlined-multi"
                size="small"
                noOptionsText="Loading..."
                value={currentProject.tag}
                componentsProps={{ popper: { style: { width: 'fit-content' } } }}
                options={projects.map(r => r.tag)}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" placeholder={`Stores   ( ${projects.length} )`} />
                )}
                onChange={(event, value) => handleOptionChange(value, "project")}
              />}
          </Stack>
        </Stack>

        {/* project info/switcher */}
        <Projects />
      </Paper>
    </animated.div>
  )
}